const httpProvider = function ($httpProvider) {
    $httpProvider.defaults.withCredentials = true;
};

httpProvider.$inject = ["$httpProvider"];
export default httpProvider;
